module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f98b.64342de0.svg";